<template>
  <footer class="footer">
    <div v-for="(block, key) in footer" :key="key" :class="key">
      <template v-for="(row, i) in block" :key="i">
        <span v-if="row.type === 'text'">{{ t(`footer.${row.label}`) }}</span>

        <span v-if="row.type === 'img'" class="footer-images">
          <img v-for="(img, i) in row.images" :key="i" :src="img" alt="" />
        </span>

        <a v-if="row.type === 'a'" :href="row.href"> {{ t(`footer.${row.label}`) }} </a>
      </template>
    </div>
  </footer>
</template>

<script>
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'VFooter',
  props: {
    config: {
      type: Object,
      required: true
    }
  },

  setup(props) {
    const { t } = useI18n()

    const footer = JSON.parse(props.config.footer || '{}')

    return {
      footer,
      t
    }
  }
})
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: center;
  align-items: start;
  color: var(--font_second);
  line-height: 1.5;
  white-space: nowrap;
  font-size: 18px;

  .left-block,
  .center-block,
  .right-block,
  .other-block {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 0.5rem 1rem;
  }

  .center-block {
    display: flex;
    justify-content: center;
    text-align: center;
  }

  .footer-images {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    height: 30px;
    margin: 5px 4px;
    user-select: none;
  }

  a {
    &:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .footer {
    flex-direction: column;
    align-items: center;

    .left-block,
    .center-block,
    .right-block {
      margin-bottom: 1rem;
      width: 100%;
      display: flex;
      align-items: center;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
